import React, { useState, useEffect } from 'react';
import { Image } from 'semantic-ui-react';
import { flattenToAppURL } from '@plone/volto/helpers';

import './theme/_main.scss';

import TextLineEdit from '@plone/volto/components/manage/TextLineEdit/TextLineEdit';
import { UniversalLink } from '@plone/volto/components';

const View = (props) => {
  const { data, isEditMode, filteredToolbarProps } = props;
  const [windowWidth, setWindowWidth] = useState(undefined);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      setWindowWidth(window.innerWidth);
      const handleResize = () => setWindowWidth(window.innerWidth);
      window.addEventListener('resize', handleResize);
      return () => window.removeEventListener('resize', handleResize);
    }
  }, []);

  const left = (
    <div
      id={data.scroll_id}
      className={`six wide computer twelve wide mobile six wide tablet column column-blocks-wrapper info`}
    >
      {isEditMode ? (
        <TextLineEdit
          {...filteredToolbarProps}
          renderTag="h4"
          renderClassName=""
          fieldDataName="title"
          properties={{ title: data.title }}
        />
      ) : (
        <h4>{data.title}</h4>
      )}
      {isEditMode ? (
        <TextLineEdit
          {...filteredToolbarProps}
          renderTag="p"
          renderClassName=""
          fieldDataName="text"
          properties={{ text: data.text }}
        />
      ) : (
        <p>{data.text}</p>
      )}

      <div className="ui twelve column grid column-grid">
        <div className="six wide computer twelve wide mobile six wide tablet column column-blocks-wrapper">
          {data.map_image && data.map_image['@id'] && (
            <Image
              src={flattenToAppURL(data.map_image['@id'] + '/@@images/image')}
              alt={data.map_image.title}
            />
          )}
        </div>
        <div className="six wide computer twelve wide mobile six wide tablet column column-blocks-wrapper meta">
          <span>
            <i className="location"></i>
            {data.adress}
          </span>
          <span>
            <i className="person"></i>
            {data.name}
          </span>
          <a href={`mailto:${data.mail}`}>
            <span>
              <i className="mail">icon</i>
              {data.mail}
            </span>
          </a>
          <UniversalLink href={data.button_link} className="zentrums-link">
            {data.button_text}
          </UniversalLink>
        </div>
      </div>
    </div>
  );

  const rightMobile = (
    <div className="six wide computer twelve wide mobile six wide tablet column column-blocks-wrapper image-wrapper mobile">
      {data.image_1 && data.image_1['@id'] && (
        <Image
          src={flattenToAppURL(data.image_1['@id'] + '/@@images/image')}
          alt={data.image_1.title}
          className="mobile-image"
        />
      )}
      {data.image_2 && data.image_2['@id'] && (
        <Image
          src={flattenToAppURL(data.image_2['@id'] + '/@@images/image')}
          alt={data.image_2.title}
          className="mobile-image"
        />
      )}
    </div>
  );

  const rightDesktop = (
    <div className="six wide computer twelve wide mobile six wide tablet column column-blocks-wrapper image-wrapper">
      {data.image_1 && data.image_1['@id'] && (
        <Image
          src={flattenToAppURL(data.image_1['@id'] + '/@@images/image')}
          alt={data.image_1.title}
          className={`image-big ${data.mirror ? 'image-big-left' : 'image-big-right'}`}
        />
      )}
      {data.image_2 && data.image_2['@id'] && (
        <Image
          src={flattenToAppURL(data.image_2['@id'] + '/@@images/image')}
          alt={data.image_2.title}
          className={`image-small ${data.mirror ? 'image-small-left' : 'image-small-right'}`}
        />
      )}
    </div>
  );

  const images = windowWidth < 1200 ? rightMobile : rightDesktop;

  return (
    <div className="custom-block zentrums-block">
      <div className="ui twelve column grid column-grid">
        {windowWidth < 768 ? (
          <>
            {left}
            {images}
          </>
        ) : data.mirror ? (
          <>
            {left}
            {images}
          </>
        ) : (
          <>
            {images}
            {left}
          </>
        )}
      </div>
    </div>
  );
};

export default View;
